<div *ngIf="member$ | async as member">
  <form [formGroup]="detailsForm" class="my-details-edit">
    <div class="detail-list">
      <div class="detail-field-box">
        <div class="detail-field-text">
          <label class="detail-field-label" for="edit-account-details-dob">{{
            'account.my-details.dob' | translate : { fgbdefault: 'Date of birth' }
          }}</label>
          <input
            id="edit-account-details-dob"
            type="text"
            class="detail-field-input"
            formControlName="dateOfBirth"
            ngbDatepicker
            [minDate]="{ year: 1930, month: 1, day: 1 }"
            [maxDate]="{ year: maxYear, month: currentMonth, day: currentDate }"
            [startDate]="{ year: maxYear, month: currentMonth, day: currentDate }"
            #dobDatePicker="ngbDatepicker"
            (click)="dobDatePicker.toggle()"
          />
        </div>
        <span class="icon material-icons detail-field-icon" aria-hidden="true">calendar_today</span>
      </div>

      <div class="detail-field-box">
        <div class="detail-field-text">
          <label class="detail-field-label" for="edit-account-details-email">{{
            'account.my-details.email' | translate : { fgbdefault: 'Email Address' }
          }}</label>
          <input id="edit-account-details-email" type="text" class="detail-field-input" formControlName="emailAddress" />
        </div>
      </div>

      <div class="detail-field-box">
        <div class="detail-field-text">
          <label class="detail-field-label" for="edit-account-details-street">{{
            'account.my-details.address' | translate : { fgbdefault: 'Address' }
          }}</label>
          <input id="edit-account-details-street" type="text" class="detail-field-input" formControlName="street" />
        </div>
      </div>

      <div ngbDropdown placement="bottom-start" container="body" [autoClose]="true" #countryField>
        <button type="button" id="edit-account-details-country" class="detail-field-toggle" ngbDropdownToggle>
          <span class="detail-field-text">
            <span class="detail-field-label">{{
              'account.my-details.country' | translate : { fgbdefault: 'Country' }
            }}</span>
            <span class="detail-field-value">{{
              selectedCountryDisplayName || ('country.options.default.select' | translate : { fgbdefault: 'Select country' })
            }}</span>
          </span>
          <span class="icon material-icons detail-field-icon" aria-hidden="true">keyboard_arrow_down</span>
        </button>
        <div
          ngbDropdownMenu
          aria-labelledby="edit-account-details-country"
          class="detail-field-menu"
          [style.width.px]="countryField.offsetWidth"
        >
          <button
            type="button"
            ngbDropdownItem
            *ngFor="let countryOption of countryOptions"
            class="detail-field-option"
            [class.active]="detailsForm.controls.country.value === countryOption.CountryName"
            (click)="selectCountry(countryOption)"
          >
            {{ countryOption.DisplayName }}
          </button>
        </div>
      </div>

      <div class="detail-field-box">
        <div class="detail-field-text">
          <label class="detail-field-label" for="edit-account-details-county">{{
            'account.my-details.county' | translate : { fgbdefault: 'County' }
          }}</label>
          <select
            *ngIf="regionOptions.length; else countyFallback"
            id="edit-account-details-county"
            class="detail-field-input detail-field-select"
            formControlName="county"
          >
            <option value="" selected disabled hidden>
              {{ 'region.options.default.select' | translate : { fgbdefault: 'Select county' } }}
            </option>
            <option *ngFor="let region of regionOptions" [value]="region.RegionName">
              {{ region.DisplayName }}
            </option>
          </select>
          <ng-template #countyFallback>
            <input id="edit-account-details-county" type="text" class="detail-field-input" formControlName="county" />
          </ng-template>
        </div>
        <span *ngIf="regionOptions.length" class="icon material-icons detail-field-icon" aria-hidden="true">keyboard_arrow_down</span>
      </div>

      <div class="detail-field-box">
        <div class="detail-field-text">
          <label class="detail-field-label" for="edit-account-details-postcode">{{
            'account.my-details.postcode' | translate : { fgbdefault: 'Post Code' }
          }}</label>
          <input id="edit-account-details-postcode" type="text" class="detail-field-input" formControlName="postcode" />
        </div>
      </div>
    </div>

    <fgb-alert-preferences [editMode]="notInAnyEditMode()" [portalId]="portalId"></fgb-alert-preferences>

    <ng-container *ngIf="isLoading">
      <fgbcl-loading></fgbcl-loading>
    </ng-container>
    <div class="my-details-actions edit-actions" *ngIf="!isLoading">
      <button type="button" class="btn-text-danger" (click)="stopEditing()">
        {{ 'account.my-details.cancel' | translate : { fgbdefault: 'Cancel' } }}
      </button>
      <button type="button" class="btn-filled-success" [disabled]="disableIfFormIncomplete() === 'disabled'" (click)="save()">
        {{ 'account.my-details.confirm' | translate : { fgbdefault: 'Confirm' } }}
      </button>
    </div>
  </form>
</div>
